// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/emails/email/index.scss';

// Packages
import Cookies from 'js-cookie';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Blocks
import initRequestForm from '~scripts/blocks/request-form';
import initSubscribeForm from '~scripts/blocks/subscribe-form';

// Components
import '~scripts/components/modals';

//
// HEADER
//
import Header from '~scripts/blocks/header';
//
// NAVIGATION
//
import Navigation from '~scripts/blocks/navigation';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

Header();

Navigation();
//
// ENVELOPES
//
// Animation
const banner = document.querySelector('.js-banner');
let bannerHeight = banner.offsetHeight;

const envelopesAnimation = () => {
  const envelopesAnimationBlock = document.querySelector('.js-envelopes-animation-block');

  return scrollAnimationProgress(envelopesAnimationBlock, {
    getStart() {
      return 0;
    },
    getEnd(el, start) {
      return start + bannerHeight - bannerHeight / (mediaSm.matches ? 1.9 : 2.4);
    },
    lerpValue: 1,
  });
};

envelopesAnimation();
window.addEventListener('resize', () => {
  bannerHeight = banner.offsetHeight;
  envelopesAnimation();
});

//
// FORMS
//
// Demo request
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

// Download PDF
const downloadPdfForm = document.querySelectorAll('.js-download-form');

const redirectUserToThankYouPage = () => {
  const currentUrl = window.location.origin + window.location.pathname.replace(/\/+$/, '');
  Cookies.set('thankYouPageAccess', true);
  window.location.href = `${currentUrl}/thank-you`;
};

downloadPdfForm.forEach((form) => {
  initSubscribeForm(form, redirectUserToThankYouPage);

  const submit = form.querySelector('[type="submit"]');
  submit.addEventListener('click', () => {
    window.downloadEmail();
  });
});
